import { render, staticRenderFns } from "./serveTab6.vue?vue&type=template&id=3d8c4b00&scoped=true"
import script from "./serveTab6.vue?vue&type=script&lang=js"
export * from "./serveTab6.vue?vue&type=script&lang=js"
import style0 from "./serveTab6.vue?vue&type=style&index=0&id=3d8c4b00&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d8c4b00",
  null
  
)

export default component.exports